import request from '@/utils/axios.js'
// 获取id 记录
export function Operator (params){
    return request({
        url:'/api/contract/info',
        method:'get',
        params
    });
}

// 生成 合同id 记录
export function Generated (data){
    return request({
        url:'/api/contract/createContract',
        method:'post',
        data
    });
}

// 提交文件数据
export function FileSubmit (data){
    return request({
        url:'/api/contract/edit',
        method:'post',
        data
    });
}

// 提交文件数据
export function FileSave (data){
    return request({
        url:'/api/contract/save',
        method:'post',
        data
    });
}
